export default "__VITE_ASSET__DO7S0rT$__"